import type { MarketReportKeyFinding } from '@horwath-htl/shared-types';

export interface KeyFindingsResponse {
  reportId: number;
  marketId: number;
  marketName: string;
  reportMonth: string;
  findings: MarketReportKeyFinding[];
}

interface UseKeyFindingsOptions {
  apiUrl: string;
  authenticatedFetch: (url: string, options?: any) => Promise<Response | null>;
}

export function createKeyFindingsQueryConfig({ apiUrl, authenticatedFetch }: UseKeyFindingsOptions) {
  return {
    getKeyFindings: (reportId: number) => ({
      queryKey: ['keyFindings', reportId],
      queryFn: async () => {
        const response = await authenticatedFetch(`${apiUrl}/api/marketcompass/reports/${reportId}/key-findings`);
        
        if (!response) {
          throw new Error('Failed to fetch key findings');
        }
        
        if (!response.ok) {
          throw new Error(`Failed to fetch key findings: ${response.statusText}`);
        }
        
        const data = await response.json();
        return data;
      },
      staleTime: 0, // No caching
      gcTime: 0, // No caching
      enabled: !!reportId
    }),
    
    getMarketKeyFindings: (marketId: number, months: number = 12) => ({
      queryKey: ['marketKeyFindings', marketId, months],
      queryFn: async () => {
        const response = await authenticatedFetch(
          `${apiUrl}/api/marketcompass/markets/${marketId}/key-findings?months=${months}`
        );
        
        if (!response) {
          throw new Error('Failed to fetch market key findings');
        }
        
        if (!response.ok) {
          throw new Error(`Failed to fetch market key findings: ${response.statusText}`);
        }
        
        const data = await response.json();
        return data;
      },
      staleTime: 0,
      gcTime: 0,
      enabled: !!marketId
    })
  };
}